export default __webpack_public_path__ + "static/background-1-c1be898b2c18940c7512830eeb83016d.png";